import React, { useEffect, useState } from 'react'
import { Button, Empty, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import './index.scss'
import CustomerReviewDetailModel from './CustomerReviewDetailModel'

export default function CustomerReviewList({ isOpen, onClose, stationsId, callBackBooking, apiFunction, fieldMapper, title, emptyText }) {
  const [list, setList] = useState([])
  const [totalNextPage, setTotalNextPage] = useState(0)
  const { t: translation } = useTranslation()
  const [filter, setFilter] = useState({
    limit: 10,
    skip: 0,
    filter: {
      stationsId: stationsId
    },
    order: {
      key: 'createdAt',
      value: 'desc'
    }
  })
  const getData = (payload) => {
    if (!stationsId) {
      return
    }
    apiFunction &&
      apiFunction(payload).then((result) => {
        if (result?.statusCode === 200) {
          setList(result?.data?.data || [])
          const data = result?.data?.data
          const newData = payload?.skip > 0 ? [...list, ...data] : data
          setList(newData)
          setTotalNextPage(result?.data?.total || 0)
          setFilter(payload)
        }
      })
  }

  useEffect(() => {
    const payload = {
      ...filter,
      filter: {
        ...filter.filter,
        stationsId: stationsId
      }
    }
    isOpen && getData(payload)
  }, [isOpen, stationsId])

  return (
    <Modal onCancel={onClose} centered width={600} footer={null} open={isOpen}>
      <div
        className={`mt-3 review-header sticky-header d-flex text-normal fw-bold ai-c j-sb`}
        style={{ backgroundColor: 'transparent', color: 'var(--title-color)', height: '25px' }}>
        <div className="d-flex ai-c mg-auto">
          <div className="title text-uppercase">{title}</div>
        </div>
      </div>
      <div className="CustomerReviewList-wrapper">
        {list.map((item, index) => (
          <div key={index} className="w-100">
            <CustomerReviewDetailModel
              {...fieldMapper(item)}
              // đây là mẫu
              // name={item?.firstName}
              // avatar={item?.userAvatar}
              // ratingPoint={item?.ratingPoint}
              // content={item?.reviewContent}
              // updatedAt={item?.updatedAt}
            />
          </div>
        ))}
        {totalNextPage > 0 && (
          <div
            className="CustomerReviewList-seeMore"
            onClick={() => {
              const newPayload = { ...filter, skip: filter?.skip + filter.limit }
              getData(newPayload)
            }}>
            {translation('See_more')}
          </div>
        )}
        {list.length === 0 && (
          <div className="CustomerReviewList-empty">
            <Empty description={emptyText}></Empty>
          </div>
        )}
      </div>
      {/* <div className="w-100 d-flex justify-content-center" style={{ gap: '0 20px' }}>
        <Button
          className="login__button df mt-3 custom-default-btn"
          type="primary"
          onClick={() => {
            callBackBooking && callBackBooking()
          }}
          size="large">
          {translation('Booking')}
        </Button>
      </div> */}
    </Modal>
  )
}
